import React, {useState, useEffect} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import CustomFormBlock from '../../../pieces/inputs/formBlock';
import {inputTypes} from '../../../pieces/inputs/formInput';
import * as allConstants from '../../../constants/allConstants';
import SelectJobType from './pieces/selectJobType';
import Utils from '../../../utils/utils';
import {Box, Typography, Grid} from '@mui/material';
import {JobPaperWrapper} from './pieces/jobPaperWrapper';
import {globalUseClasses} from '../../../styles/globalClasses';
import {useCreateJobStyles} from './createJobStyles';
import {jobShowFieldRules} from './fieldRules';
import {useFormContext, useWatch} from 'react-hook-form';
import * as STYLE_CONSTANTS from '../../../styles/styleConstants';
// import base_url from '../../../baseUrls';
// import ApiUtils from '../../../utils/apiUtils';
// import axios from 'axios';

const GeneralStep = (props)=> {

  console.log('inside General Step - props');
  console.log(props);

  const [showOtherRebateName, setShowOtherRebateName] = useState(false);
  const [showRebateProgram, setShowRebateProgram] = useState(false);

  const options = Utils.getOptions(props.allowedPermits);
  const classes = {...globalUseClasses(), ...useCreateJobStyles()};

  const showHERS = jobShowFieldRules.showHERS(props.jobType, props.propertyType, props.allowedTests);
  const showEUC = jobShowFieldRules.showEUC(props.jobType, props.propertyType, props.allowedTests);
  const showAsbestos = jobShowFieldRules.showAsbestos(props.jobType);
  const showNewConstr = jobShowFieldRules.showNewConstruction(props.jobType);

  const isTestingOnly = props.jobType && props.jobType === allConstants.JOB_TYPES.TESTING_ONLY.value;
  const isBL = props.jobType && props.jobType === allConstants.JOB_TYPES.BUSINESS_LIC.value;
  const showCityFee = props.jobType === allConstants.JOB_TYPES.INSPECTION_ONLY.value;

  const formController = useFormContext();

  const values = formController.getValues();

  const selectedRebateId = useWatch({
    name: `${allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name}.${allConstants.REBATE_FIELDS.ID.api_name}`,
    control: formController.control
  });

  const rebateAnswer = useWatch({
    name: `${allConstants.JOB_FIELDS.GENERAL.EUC_TEST_REQUIRED.api_name}`,
    control: formController.control
  });

  const clearRebateProgram = () => {
    formController.setValue(`${allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name}.${allConstants.REBATE_FIELDS.REBATE_NAME.api_name}`, '');
    //formController.setValue(`${allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name}.${allConstants.REBATE_FIELDS.DATE_EXPIRED.api_name}`, null); 
    formController.setValue(`${allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name}.${allConstants.REBATE_FIELDS.OTHER_REBATE_NAME.api_name}`, ''); 
    setShowOtherRebateName(false);

  };

  useEffect ( () => {

    if (props.userCompanyList.length <= 0)
      return;

    // This step remounts on Previous. Overwriting a company the user already picked
    // makes the Company select and the form trade values on every render until React
    // aborts with "Maximum update depth exceeded" - so keep any valid choice.
    const currentCompanyId = formController.getValues(allConstants.JOB_FIELDS.COMPANY_ID.api_name);
    if (currentCompanyId && props.userCompanyList.some((x) => String(x.value) === String(currentCompanyId)))
      return;

    if (values.company == undefined) {
      formController.setValue(allConstants.JOB_FIELDS.COMPANY_ID.api_name, props.userCompanyList[0].value);
    }
    else {
      formController.setValue(allConstants.JOB_FIELDS.COMPANY_ID.api_name, values.company.id);
    }

  },[props.userCompanyList])

  useEffect ( () => {

    // setShowRebateProgram (rebateAnswer);

    // if (!rebateAnswer) {
    //   clearRebateProgram();
    // }

  }, [rebateAnswer]);

  useEffect ( async() => {

    const rebate = props.availableRebates.find( x => x.value == selectedRebateId);
    if (rebate?.name === 'None') {
      clearRebateProgram();
    }
    else if (rebate?.name === 'Other') {
      formController.setValue(`${allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name}.${allConstants.REBATE_FIELDS.REBATE_NAME.api_name}`, rebate?.name);
      //formController.setValue(`${allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name}.${allConstants.REBATE_FIELDS.DATE_EXPIRED.api_name}`, null); 
      setShowOtherRebateName(true);
    }
    else {
      formController.setValue(`${allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name}.${allConstants.REBATE_FIELDS.REBATE_NAME.api_name}`, rebate?.name);
      //formController.setValue(`${allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name}.${allConstants.REBATE_FIELDS.DATE_EXPIRED.api_name}`, rebate?.dateExpired); 
      formController.setValue(`${allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name}.${allConstants.REBATE_FIELDS.OTHER_REBATE_NAME.api_name}`, ''); 
      setShowOtherRebateName(false);
    }

  },[selectedRebateId]);

  const isDraft = props?.draftData?.[allConstants.JOB_FIELDS.IS_DRAFT.api_name];

  const getDefaultValue = (field, parent = null) => {
    if (parent) {
      return values?.[parent]?.[field];
    }
    return values?.[field];
  };

  const getValue = (field, parent = null) => {
    const formValues = formController.getValues();
    
    if (parent) {
      return formValues?.[parent]?.[field];
    }
    else {
      return formValues?.[field];
    }
  };

  // const getHERSValue = ()=> {
  //   const touchedFields = formController.formState.touchedFields;


  //   console.log('HERS - touched fields => ', touchedFields);
  //   console.log('HERS - is draft => ', isDraft);

  //   if(Utils.objectHasProperty(touchedFields, allConstants.JOB_FIELDS.GENERAL.HERS_TEST_REQUIRED.api_name)) {
  //     const formValues = formController.getValues();

  //     console.log('HERS - form values');
  //     console.log(formValues);

  //     const hersIsRequired = formValues[allConstants.JOB_FIELDS.GENERAL.HERS_TEST_REQUIRED.api_name];
  //     return hersIsRequired ? allConstants.ANSWER_OPTIONS.YES.value : allConstants.ANSWER_OPTIONS.NO.value;
  //   }

  //   console.log('HERS - job type => ', props.jobType);

  //   if(props.jobType === allConstants.JOB_TYPES.TESTING_ONLY.value) return allConstants.ANSWER_OPTIONS.YES.value;
  
  //   console.log('HERS - is draft => ', isDraft);

  //   if(isDraft) {

  //     console.log('HERS - draft data');
  //     console.log(props?.draftData);


  //     return props?.draftData?.[allConstants.JOB_FIELDS.GENERAL.HERS_TEST_REQUIRED.api_name] ? allConstants.ANSWER_OPTIONS.YES.value : allConstants.ANSWER_OPTIONS.NO.value;
  //   }
  //   if(props.jobType === allConstants.JOB_TYPES.HVAC_RES.value) {
  //     if(!showHERS) return allConstants.ANSWER_OPTIONS.NO.value;

  //     if(props.isDuplicate) return allConstants.ANSWER_OPTIONS.NO.value;
  //     if(props.propertyType === allConstants.PROPERTY_TYPES.MOBILE_HOME.value) return allConstants.ANSWER_OPTIONS.NO.value;
  //     return allConstants.ANSWER_OPTIONS.YES.value;
  //   }
  //   return allConstants.ANSWER_OPTIONS.NO.value;
  // };

  const getHERSValue = ()=> {
    const touchedFields = formController.formState.touchedFields;
    const formValues = formController.getValues();
    const currentValue = formValues[allConstants.JOB_FIELDS.GENERAL.HERS_TEST_REQUIRED.api_name];
    
    // If field has been touched or has a current value, use that value
    if(Utils.objectHasProperty(touchedFields, allConstants.JOB_FIELDS.GENERAL.HERS_TEST_REQUIRED.api_name) || currentValue) {
      return currentValue ? allConstants.ANSWER_OPTIONS.YES.value : allConstants.ANSWER_OPTIONS.NO.value;
    }

    if(props.jobType === allConstants.JOB_TYPES.TESTING_ONLY.value ) {
      return allConstants.ANSWER_OPTIONS.YES.value;
    }
    if(isDraft) {
      return props?.draftData?.[allConstants.JOB_FIELDS.GENERAL.HERS_TEST_REQUIRED.api_name] ? allConstants.ANSWER_OPTIONS.YES.value : allConstants.ANSWER_OPTIONS.NO.value;
    }
    if(props.jobType === allConstants.JOB_TYPES.HVAC_RES.value) {
      if(!showHERS) return allConstants.ANSWER_OPTIONS.NO.value;
      if(props.isDuplicate) return allConstants.ANSWER_OPTIONS.NO.value;
      if(props.propertyType === allConstants.PROPERTY_TYPES.MOBILE_HOME.value) return allConstants.ANSWER_OPTIONS.NO.value;

      if(props.hersRequireDefault)
         return allConstants.ANSWER_OPTIONS.YES.value;
      else 
         return allConstants.ANSWER_OPTIONS.NO.value
      
      //return allConstants.ANSWER_OPTIONS.YES.value;
    }
    return allConstants.ANSWER_OPTIONS.NO.value;
  };

  const getEUCValue = ()=> {
    const touchedFields = formController.formState.touchedFields;
    if(Utils.objectHasProperty(touchedFields, allConstants.JOB_FIELDS.GENERAL.EUC_TEST_REQUIRED.api_name)) {
      const formValues = formController.getValues();
      const eucIsRequired = formValues[allConstants.JOB_FIELDS.GENERAL.EUC_TEST_REQUIRED.api_name];
      return eucIsRequired ? allConstants.ANSWER_OPTIONS.YES.value : allConstants.ANSWER_OPTIONS.NO.value;
    } else if(isDraft) {
      return props?.draftData?.[allConstants.JOB_FIELDS.GENERAL.EUC_TEST_REQUIRED.api_name] ? allConstants.ANSWER_OPTIONS.YES.value : allConstants.ANSWER_OPTIONS.NO.value;
    }
    return allConstants.ANSWER_OPTIONS.NO.value;
  };

  return (
    <>
      {isDraft && <Box mt={2}>
        <Typography sx={{color: STYLE_CONSTANTS.COLORS.globalRed}}>*Submitted on Service Titan - Job Type is not editable</Typography>
      </Box>}

      <Box ref={props.refs[allConstants.JOB_FIELDS.JOB_TYPE.api_name]}
        display={'flex'} justifyContent={'center'} sx={{
          '& .MuiFormControl-root': {
            width: 'unset'
          },
          '& .MuiFormHelperText-root': {
            alignSelf: 'center',
            fontSize: '14px'
          }
        }}>

        <CustomFormBlock
          {...props}
          maxWidth={'100vw'}
          inputType={inputTypes.radio}
          field={allConstants.JOB_FIELDS.JOB_TYPE}
          nested={false}
          fullWidth={true}
          defaultValue={props.jobType}
          renderLabel={false}
          disabled={isDraft}
          items={<SelectJobType allowedJobs={options}
            selected={props.jobType}
            isDraft={isDraft}
            onMouseDown={true}/>}
        >
        </CustomFormBlock>
      </Box>
      {!isBL && <Box>
        <JobPaperWrapper showHeader header={'General Information'}>
          <Grid container justifyContent={'center'} spacing={{md: 6, lg: 12}}>
            <Grid item xs={12} sm={12} md={6} className={clsx(classes.general_col)}>
  
              {/* CreateJobForm: changing this field or clicking Next on the general step shows a Got It popup if the chosen row has canCreateJob !== true. */}
              <Box ref={props.refs[allConstants.JOB_FIELDS.COMPANY_ID.api_name]}>
                <CustomFormBlock
                      {...props}
                      inputType={inputTypes.singleSelect}
                      labelSecondary={true} 
                      field={allConstants.JOB_FIELDS.COMPANY_ID}
                      fullWidth={true}
                      options={props.userCompanyList}
                      defaultValue={getDefaultValue(allConstants.JOB_FIELDS.COMPANY_ID.api_name)}
                    />
              </Box>
              <Box ref={props.refs[allConstants.JOB_FIELDS.GENERAL.HO_NAME.api_name]}>
                <CustomFormBlock
                  {...props}
                  labelSecondary={true}
                  field={allConstants.JOB_FIELDS.GENERAL.HO_NAME}
                  fullWidth={true}
                  nested={true}
                  parent={allConstants.JOB_FIELDS.GENERAL.HOMEOWNER.api_name}
                  defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.HOMEOWNER.api_name]?.[allConstants.JOB_FIELDS.GENERAL.HO_NAME.api_name]}
                />
              </Box>
              <Box ref={props.refs[allConstants.JOB_FIELDS.GENERAL.HO_PHONE.api_name]}>
                <CustomFormBlock
                  {...props}
                  inputType={inputTypes.phone}
                  labelSecondary={true}
                  field={allConstants.JOB_FIELDS.GENERAL.HO_PHONE}
                  fullWidth={true}
                  nested={true}
                  parent={allConstants.JOB_FIELDS.GENERAL.HOMEOWNER.api_name}
                  defaultValue={Utils.reformatPhoneNumber(values?.[allConstants.JOB_FIELDS.GENERAL.HOMEOWNER.api_name]?.[allConstants.JOB_FIELDS.GENERAL.HO_PHONE.api_name])}
                />
              </Box>
              <CustomFormBlock
                {...props}
                inputType={inputTypes.phone}
                labelSecondary={true}
                field={allConstants.JOB_FIELDS.GENERAL.ALT_HO_PHONE}
                fullWidth={true}
                nested={true}
                parent={allConstants.JOB_FIELDS.GENERAL.HOMEOWNER.api_name}
                defaultValue={Utils.reformatPhoneNumber(values?.[allConstants.JOB_FIELDS.GENERAL.HOMEOWNER.api_name]?.[allConstants.JOB_FIELDS.GENERAL.ALT_HO_PHONE.api_name])}
              />
              <CustomFormBlock
                {...props}
                labelSecondary={true}
                field={allConstants.JOB_FIELDS.GENERAL.HO_EMAIL}
                fullWidth={true}
                nested={true}
                parent={allConstants.JOB_FIELDS.GENERAL.HOMEOWNER.api_name}
                defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.HOMEOWNER.api_name]?.[allConstants.JOB_FIELDS.GENERAL.HO_EMAIL.api_name]}
              />
              <Box className={classes.two_col_container}>
                <Box ref={props.refs[allConstants.JOB_FIELDS.GENERAL.PROPERTY_TYPE.api_name]}>
                  <CustomFormBlock
                    {...props}
                    inputType={inputTypes.singleSelect}
                    labelSecondary={true}
                    field={allConstants.JOB_FIELDS.GENERAL.PROPERTY_TYPE}
                    options={Utils.getOptions(allConstants.PROPERTY_TYPES)}
                    defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.PROPERTY_TYPE.api_name]}
                    fullWidth={true}
                  />
                </Box>
                <Box ref={props.refs[allConstants.JOB_FIELDS.GENERAL.JOB_VALUE.api_name]}>
                  <CustomFormBlock
                    {...props}
                    inputType={inputTypes.currency}
                    labelSecondary={true}
                    field={{...allConstants.JOB_FIELDS.GENERAL.JOB_VALUE, ...{required: !isTestingOnly}}}
                    fullWidth={true}
                    defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.JOB_VALUE.api_name]}
                    //transform={(val)=> val.parseInt()}
                  />
                </Box>
              </Box>
              {isTestingOnly &&  <Box className={classes.two_col_container}>
                <Box>
                  <CustomFormBlock
                    {...props}
                    labelSecondary={true}
                    nested={true}
                    parent={allConstants.PERMIT_MODULE_FIELDS.PERMIT_INFO.api_name}
                    field={{...allConstants.PERMIT_MODULE_FIELDS.NUMBER, ...{label: 'Permit Number'}}}
                    fullWidth={true}
                    defaultValue={values?.[allConstants.PERMIT_MODULE_FIELDS.PERMIT_INFO.api_name]?.[allConstants.PERMIT_MODULE_FIELDS.NUMBER.api_name]}
                  />
                </Box>
                <Box>
                  <CustomFormBlock
                    {...props}
                    labelSecondary={true}
                    inputType={inputTypes.date}
                    nested={true}
                    parent={allConstants.PERMIT_MODULE_FIELDS.PERMIT_INFO.api_name}
                    field={{...allConstants.PERMIT_MODULE_FIELDS.DATE, ...{label: 'Permit Date'}}}
                    fullWidth={true}
                    defaultValue={values?.[allConstants.PERMIT_MODULE_FIELDS.PERMIT_INFO.api_name]?.[allConstants.JOB_FIELDS.PERMIT_DATE.api_name]?.toString()}
                  />
                </Box>
              </Box>}
            </Grid>
            <Grid item xs={12} sm={12} md={6} className={clsx(classes.general_col)}>
              <Box ref={props.refs[allConstants.JOB_FIELDS.GENERAL.JOBSITE_ADDRESS.api_name]}>
                <CustomFormBlock
                  {...props}
                  inputType={inputTypes.address}
                  field={allConstants.JOB_FIELDS.GENERAL.JOBSITE_ADDRESS}
                  fullWidth
                  //methods={formMethods}
                  defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.JOBSITE_ADDRESS.api_name]}
                  // setValueToForm={formMethods.setValueToForm}
                  renderLabel={false}
                />
              </Box>
              <Box className={classes.three_col_container}>
                <Box>
                  <CustomFormBlock
                    {...props}
                    labelSecondary={true}
                    inputType={inputTypes.number}
                    field={allConstants.JOB_FIELDS.GENERAL.SQFT}
                    defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.SQFT.api_name]}
                  />          
                </Box>
                {showHERS && !isTestingOnly && 
                <Box><CustomFormBlock
                  {...props}
                  inputType={inputTypes.singleSelect}
                  labelSecondary={true}
                  field={allConstants.JOB_FIELDS.GENERAL.HERS_TEST_REQUIRED}
                  options={Utils.getOptions(allConstants.ANSWER_OPTIONS)}
                  defaultValue={getHERSValue()}
                /></Box>}
                {showEUC && 
                <Box><CustomFormBlock
                    {...props}
                    inputType={inputTypes.singleSelect}
                    labelSecondary={true}
                    field={allConstants.JOB_FIELDS.GENERAL.EUC_TEST_REQUIRED}
                    options={Utils.getOptions(allConstants.ANSWER_OPTIONS)}
                    defaultValue={getEUCValue()}
                    fullWidth={true}
                /></Box>}
              </Box>
              {showEUC && showRebateProgram && <>
                  <CustomFormBlock
                    {...props}
                    inputType={inputTypes.singleSelect}
                    labelSecondary={true}
                    nested={true}
                    parent={allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name}
                    field={allConstants.REBATE_FIELDS.ID}
                    fullWidth={true}
                    options={props.availableRebates}
                    defaultValue={getDefaultValue(allConstants.REBATE_FIELDS.ID.api_name, allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name)}
                  />
                  <CustomFormBlock
                    {...props}
                    labelSecondary={true}
                    nested={true}
                    parent={allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name}
                    field={allConstants.REBATE_FIELDS.REBATE_NAME}
                    fullWidth={true}
                    hide={true}
                    defaultValue={getDefaultValue(allConstants.REBATE_FIELDS.REBATE_NAME.api_name, allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name)}
                  />                
                  {/* <CustomFormBlock
                    {...props}
                    inputType={inputTypes.date}
                    labelSecondary={true}
                    nested={true}
                    parent={allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name}
                    field={allConstants.REBATE_FIELDS.DATE_EXPIRED}
                    fullWidth={true}
                    defaultValue={getDefaultValue(allConstants.REBATE_FIELDS.DATE_EXPIRED.api_name, allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name)}
                  /> */}
                  {showOtherRebateName &&  <CustomFormBlock
                    {...props}
                    labelSecondary={true}
                    nested={true}
                    parent={allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name}
                    field={allConstants.REBATE_FIELDS.OTHER_REBATE_NAME}
                    fullWidth={true}
                    defaultValue={getDefaultValue(allConstants.REBATE_FIELDS.OTHER_REBATE_NAME.api_name, allConstants.REBATE_FIELDS.REBATE_PROGRAM.api_name)}
                  />}               
              </>}
              <Box className={classes.two_col_container}>
                <CustomFormBlock
                  {...props}
                  labelSecondary={true}
                  field={allConstants.JOB_FIELDS.GENERAL.CUSTOMER_JOB_NUMBER}
                  fullWidth={true}
                  defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.CUSTOMER_JOB_NUMBER.api_name]}
                />
                {showHERS && <CustomFormBlock
                  {...props}
                  labelSecondary={true}
                  field={allConstants.JOB_FIELDS.GENERAL.HERS_PO_NUMBER}
                  fullWidth={true}
                  defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.HERS_PO_NUMBER.api_name]}
                />}
              </Box>
              <Box className={classes.two_col_container}>
                {showCityFee && <Box sx={{width: '100%', paddingTop: '5px'}} >
                  <CustomFormBlock {...props} 
                    inputType={inputTypes.singleSelect}
                    options={Utils.getOptions(allConstants.ANSWER_OPTIONS, null)}
                    field={allConstants.JOB_FIELDS.GENERAL.HAS_CITY_FEE}
                    defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.HAS_CITY_FEE.api_name]}
                  />
                </Box>}
                {props.hasHomeDepotAccount && 
                  <CustomFormBlock
                    {...props}
                    labelSecondary={true}
                    field={allConstants.JOB_FIELDS.HOME_DEPOT_ID}
                    // fullWidth={true}
                    defaultValue={values?.[allConstants.JOB_FIELDS.HOME_DEPOT_ID.api_name]}
                  />
                } 
              </Box>
            </Grid>
          </Grid>
        </JobPaperWrapper>
        <JobPaperWrapper showHeader header={'More Info'}>
          <Grid container justifyContent={'center'} spacing={{md: 6, lg: 12}}>
            <Grid item xs={12} sm={12} md={6} className={clsx(classes.general_col)}>
              <CustomFormBlock
                {...props}
                inputType={inputTypes.date}
                labelSecondary={true}
                field={allConstants.JOB_FIELDS.GENERAL.START_DATE}
                defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.START_DATE.api_name]}
                fullWidth={true}
              />
              <CustomFormBlock
                {...props}
                inputType={inputTypes.date}
                labelSecondary={true}
                field={allConstants.JOB_FIELDS.GENERAL.NEED_BY_DATE}
                fullWidth={true}
                defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.NEED_BY_DATE.api_name]}
              />
              {showAsbestos && <CustomFormBlock
                {...props}
                inputType={inputTypes.singleSelect}
                labelSecondary={true}
                field={allConstants.JOB_FIELDS.GENERAL.ASBESTOS}
                options={Utils.getOptions(allConstants.ANSWER_OPTIONS)}
                defaultValue={values ? Utils.boolToText(values?.[allConstants.JOB_FIELDS.GENERAL.ASBESTOS.api_name]): allConstants.ANSWER_OPTIONS.NO.value}
                fullWidth={true}
                //transform={Utils.textToBool}
              />}
            </Grid>
            <Grid item xs={12} sm={12} md={6} className={clsx(classes.general_col)}>
              <CustomFormBlock
                {...props}
                inputType={inputTypes.singleSelect}
                labelSecondary={true}
                field={allConstants.JOB_FIELDS.GENERAL.POST_JOB_CARD}
                options={Utils.getOptions(allConstants.POST_JOB_CARD)}
                fullWidth={true}
                defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.POST_JOB_CARD.api_name]}
              />
              <CustomFormBlock
                {...props}
                inputType={inputTypes.date}
                labelSecondary={true}
                field={allConstants.JOB_FIELDS.GENERAL.INSP_REQUEST_DATE}
                fullWidth={true}
                defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.INSP_REQUEST_DATE.api_name]}
              />
              {showNewConstr && <CustomFormBlock
                {...props}
                inputType={inputTypes.singleSelect}
                labelSecondary={true}
                field={allConstants.JOB_FIELDS.GENERAL.NEW_CONSTRUCTION}
                options={Utils.getOptions(allConstants.ANSWER_OPTIONS)}
                fullWidth={true}
                defaultValue={values ? Utils.boolToText(values?.[allConstants.JOB_FIELDS.GENERAL.NEW_CONSTRUCTION.api_name]): allConstants.ANSWER_OPTIONS.NO.value}
                //transform={Utils.textToBool}
              />}
            </Grid>
          </Grid>
        </JobPaperWrapper>
      </Box>}
      {isBL &&
      <Box>
        <JobPaperWrapper showHeader header={'General Information'}>
          <Grid container justifyContent={'center'} spacing={{md: 6, lg: 12}}>
            <Grid item xs={12} sm={12} md={6} className={clsx(classes.general_col)}>
              <Box ref={props.refs[allConstants.JOB_FIELDS.GENERAL.JOB_VALUE.api_name]}>
                <CustomFormBlock
                  {...props}
                  inputType={inputTypes.currency}
                  labelSecondary={true}
                  field={{...allConstants.JOB_FIELDS.GENERAL.JOB_VALUE, ...{required: !isBL && !isTestingOnly}}}
                  fullWidth={true}
                  defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.JOB_VALUE.api_name]}
                  //transform={(val)=> val.parseInt()}
                />
              </Box>
              <CustomFormBlock
                {...props}
                labelSecondary={true}
                field={allConstants.JOB_FIELDS.BUSINESS_LIC.CITY_TO_RENEW_BL}
                fullWidth={true}
                nested={false}
                defaultValue={values?.[allConstants.JOB_FIELDS.BUSINESS_LIC.CITY_TO_RENEW_BL.api_name]}
              />
              <CustomFormBlock
                {...props}
                labelSecondary={true}
                field={allConstants.JOB_FIELDS.GENERAL.CUSTOMER_JOB_NUMBER}
                fullWidth={true}
                //transform={(val)=> val.parseInt()}
                defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.CUSTOMER_JOB_NUMBER.api_name]}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} className={clsx(classes.general_col)}>
              <CustomFormBlock
                {...props}
                inputType={inputTypes.date}
                labelSecondary={true}
                field={allConstants.JOB_FIELDS.GENERAL.START_DATE}
                defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.START_DATE.api_name]}
                fullWidth={true}
              />
              <CustomFormBlock
                {...props}
                inputType={inputTypes.date}
                labelSecondary={true}
                field={allConstants.JOB_FIELDS.GENERAL.NEED_BY_DATE}
                fullWidth={true}
                defaultValue={values?.[allConstants.JOB_FIELDS.GENERAL.NEED_BY_DATE.api_name]}
              />
            </Grid>
          </Grid>
        </JobPaperWrapper>
      </Box>}
    </>
  );

};

GeneralStep.propTypes = {
  allowedPermits: PropTypes.instanceOf(Array).isRequired,
  allowedTests: PropTypes.instanceOf(Array),
  //jobType: PropTypes.string.isRequired,
  //propertyType: PropTypes.string.isRequired,
  refs: PropTypes.instanceOf(Object).isRequired,
  draftData: PropTypes.instanceOf(Object),
  isDuplicate: PropTypes.bool,
};
GeneralStep.defaultProps = {
  allowedTests: [],
  draftData: null,
  isDuplicate: false,
};
export {GeneralStep};